import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create WhatsApp message
    const whatsappNumber = '919512300998'; // +91 9512300998
    const message = `*New Appointment Request*

*Name:* ${formData.name}
*Email:* ${formData.email}
*Phone:* ${formData.phone}
*Service:* ${formData.service}
*Message:* ${formData.message || 'No additional message'}`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

    // Open WhatsApp
    window.open(whatsappUrl, '_blank');

    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  // SEO: structured data and map references
  const coords = { latitude: 22.722812479385027, longitude: 71.63923757530492 };
  const mapPlaceUrl = `https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`;
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${coords.latitude},${coords.longitude}`;
  const businessSchema = {
    '@context': 'https://schema.org',
    '@type': 'MedicalClinic',
    name: 'Dr Vaibhav Moghariya Clinic',
    telephone: '+91 79843 64765',
    email: 'vaibhavmoghariya1209@gmail.com',
    medicalSpecialty: 'Dermatology',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Behind Axis Bank, Bus Station Road',
      addressLocality: 'Surendranagar',
      postalCode: '363002',
      addressCountry: 'IN'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: coords.latitude,
      longitude: coords.longitude
    },
    hasMap: mapPlaceUrl,
    areaServed: {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: coords.latitude,
        longitude: coords.longitude
      },
      geoRadius: 100000
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
      ],
      opens: '09:00',
      closes: '20:30'
    }
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(businessSchema) }}
        />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Get In Touch</h2>
          <p className="section-subtitle">
            Ready to start your skin transformation journey? Contact us today to schedule your consultation.
          </p>
        </motion.div>

        <div className="contact-content">
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="contact-card">
              <h3>Visit Our Clinic</h3>
              <div className="contact-detail">
                <span className="contact-icon">📍</span>
                <div>
                  <p><strong>Address:</strong></p>
                  <p>Dr Vaibhav Moghariya Clinic<br />
                    Behind Axis Bank<br />
                    Bus Station Road<br />
                    Surendranagar, Gujarat 363002</p>
                </div>
              </div>

              <div className="contact-detail">
                <span className="contact-icon">📞</span>
                <div>
                  <p><strong>Phone:</strong></p>
                  <p>+91 79843 64765</p>
                </div>
              </div>

              <div className="contact-detail">
                <span className="contact-icon">📧</span>
                <div>
                  <p><strong>Email:</strong></p>
                  <p>vaibhavmoghariya1209@gmail.com</p>
                </div>
              </div>

              <div className="contact-detail">
                <span className="contact-icon">🕒</span>
                <div>
                  <p><strong>Hours:</strong></p>
                  <p>Monday - Sunday: 9:00 AM - 8:30 PM</p>
                </div>
              </div>
            </div>

            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.146044804432!2d71.63923757530492!3d22.722812479385027!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959411f237ea5e5%3A0x483632b693803532!2sSPARSH%20SKIN%20CLINIC%20-Dr%20Vaibhav%20Moghariya-%20Best%20Skin%20Clinic%20In%20Surendranagar-Best%20Skin%20Doctor%20in%20Surendranagar!5e0!3m2!1sen!2sin!4v1754834605530!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Dr Vaibhav Moghariya Clinic Location"
              ></iframe>
              <div style={{ marginTop: '8px' }}>
                <a href={directionsUrl} target="_blank" rel="noopener noreferrer">
                  Open in Google Maps / Directions
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="contact-form-container"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <form onSubmit={handleSubmit} className="contact-form">
              <h3>Book Your Consultation</h3>

              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a Service</option>
                  <optgroup label="🌟 Skin Treatments">
                    <option value="skin-glow">Skin Glow Treatment</option>
                    <option value="acne-treatment">Acne Treatment</option>
                    <option value="acne-scar">Acne Scar Treatment</option>
                    <option value="pigmentation">Pigmentation Treatment</option>
                    <option value="open-pores">Open Pores Treatment</option>
                    <option value="anti-aging">Anti-Aging Treatment</option>
                    <option value="wrinkle-reduction">Wrinkle Reduction</option>
                    <option value="chemical-peels">Chemical Peels (TCA, Yellow Peel, Tab Peel)</option>
                    <option value="co2-laser">CO₂ Fractional Laser</option>
                    <option value="skin-brightening">Skin Brightening Therapy</option>
                  </optgroup>
                  <optgroup label="💉 Hair Treatments">
                    <option value="hair-fall">Hair Fall Treatment</option>
                    <option value="hair-prp">Hair PRP Therapy</option>
                    <option value="face-prp">Face PRP for Skin Glow</option>
                    <option value="vitamin-therapy">Vitamin Therapy</option>
                  </optgroup>
                  <optgroup label="⚡ Laser Services">
                    <option value="laser-hair-removal">Laser Hair Removal (Full Body / Face / Area-wise)</option>
                    <option value="tattoo-removal">Tattoo Removal (Active Pico Laser)</option>
                    <option value="mole-removal">Mole Removal</option>
                    <option value="wart-removal">Wart Removal</option>
                    <option value="skin-tag-removal">Skin Tag Removal</option>
                  </optgroup>
                  <optgroup label="❄️ Fat & Body Contouring">
                    <option value="cool-sculpting">Cool Sculpting (Cryolipolysis)</option>
                    <option value="fat-loss">Fat Loss Treatment</option>
                    <option value="weight-loss">Weight Loss Treatment & Counseling</option>
                    <option value="10d-lipo">10D Lipo Contouring</option>
                  </optgroup>
                  <option value="consultation">General Consultation</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Tell us about your concerns or questions..."
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              <button type="submit" className="btn-primary contact-submit">
                Send Message
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
